import { CloudDownloadOutlined, FilePdfOutlined, FileProtectOutlined, FileSearchOutlined, PrinterOutlined, SecurityScanOutlined } from "@ant-design/icons"
import { Button, Space } from "antd"
import React, { memo, useCallback } from "react";
import useSearchInvoiceService from "../../../../../helper/services/searchInvoiceServices";
import '../SearchSingleForm.css';
import { SearchSingleFunction } from "../../../../../model/searchInvoiceModels";
type invoiceProp = {
    searchFunction: SearchSingleFunction
    taxCode: string;
    securityCode: string;
}

const Toolbar: React.FC<invoiceProp> = (props) => {
    const searchService = useSearchInvoiceService();
    const downloadPdf = useCallback(() => {
        props.searchFunction(props.taxCode, props.securityCode)
            .then((blobUrl) => {
                if (!blobUrl) return;
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = blobUrl;
                a.download = "Invoice_" + props.taxCode + "_" + props.securityCode + ".pdf";
                a.click();
                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(a);
            })
    }, [props])
    const downloadXml = useCallback(() => {
        searchService
            .getXml(props.taxCode, props.securityCode)
            .then((response) => {
                if (!response) return;
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = response;
                a.download = "Invoice_" + props.taxCode + "_" + props.securityCode + ".zip";
                a.click();
                window.URL.revokeObjectURL(response);
                document.body.removeChild(a);
            })
    }, [props])
    const printConvert = useCallback(() => {
        searchService
            .getPdfInvoice(props.taxCode, props.securityCode, true)
            .then((response) => {
                if (!response) return;
                window.open(response);
            })
    }, [props])
    const readSellerToken = useCallback(() => {
        searchService.getSellerSignature(props.taxCode, props.securityCode)
            .then((response) => {
                searchService.readBuyerToken(response);
            })

    }, [props])
    return (
        <Space.Compact block={true} className="invoice-action-toolbar">
            <Button disabled={Boolean(!props.taxCode || !props.securityCode)} icon={<FilePdfOutlined />} onClick={downloadPdf}>Tải PDF</Button>
            <Button disabled={Boolean(!props.taxCode || !props.securityCode)} icon={<FileProtectOutlined />} onClick={downloadXml}>Tải XML</Button>
            <Button disabled={Boolean(!props.taxCode || !props.securityCode)} icon={<PrinterOutlined />} onClick={printConvert}>In Chuyển đổi</Button>
            <Button disabled={Boolean(!props.taxCode || !props.securityCode)} icon={<FileSearchOutlined />} href="http://tracuuhoadon.gdt.gov.vn/tc1hd.html" target="_blank">Tra cứu hóa đơn của CQT</Button>
            <Button disabled={Boolean(!props.taxCode || !props.securityCode)} icon={<SecurityScanOutlined />} onClick={readSellerToken}>Đọc CKS người bán</Button>
            <Button icon={<CloudDownloadOutlined />} href="https://installupdate.minvoice.vn/MinvoicePlugin/setup.exe" target="_blank">Tải công cụ đọc CKS</Button>
        </Space.Compact>
    )
}
export default memo(Toolbar);